import { Block, Text } from 'slate';
export default function ensureFragmentHasTextNode(editor, fragment) {
  if (fragment.getLastText()) return fragment;

  if (Block.isBlockList(fragment.nodes)) {
    if (fragment.nodes.isEmpty()) {
      return fragment.update('nodes', function (nodes) {
        return nodes.push(Text.create(''));
      });
    }

    return fragment.updateIn(['nodes', fragment.nodes.size - 1], function (node) {
      return ensureFragmentHasTextNode(editor, node);
    });
  }

  return fragment;
}